import React from 'react';
import './PopUpCardModal.css';
import {ReactComponent as CloseIcon} from "../../assets/systemIcons/ic_close.svg";
import {ReactComponent as ArrowLeftIcon} from "../../assets/systemIcons/ic_arrow_left.svg";
import {CustomModal} from "../CustomModal";
import {PopUpCard} from "../PopUpCard";

function PopUpCardModal(props) {
    const {body, title, closeAction, back, footer, fullSpace} = props;
    return (
        <CustomModal>
            <PopUpCard fullSpace={fullSpace}>
                <div className="pcmodal__container">

                    <div className="pcmodal__header">
                        <div className="pcmodal__icon__container" onClick={closeAction}>
                            <CloseIcon className="pcmodal__icon"/>
                        </div>
                        {back ? <button className="pcmodal__back__container" onClick={() => back()}><ArrowLeftIcon className="pcmodal__icon"/></button> : ""}

                        <p className="pcmodal__title">{title}</p>
                    </div>

                    <div className="pcmodal__body">
                        {body}
                    </div>

                    <div className="pcmodal__footer">
                        {footer}
                    </div>
                </div>
            </PopUpCard>
        </CustomModal>
    );
}

export default PopUpCardModal;